module.exports = __webpack_public_path__ + "bookmarkcosplay.jpg?3331c024f524d843e661b0566075734b";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/bookmarkcosplay.jpg
// module id = 606
// module chunks = 0